import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const kentik = defineConnector({
  identifier: "kentik",
  name: "Kentik",
  tagLine: "Network observability and analytics",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://api\\.kentik\\.(com|eu)/.*",
  auth: (app) =>
    headerAuth([
      { name: "X-CH-Auth-Email", value: app.config.email },
      {
        name: "X-CH-Auth-API-Token",
        value: app.secret.apiToken,
      },
    ]),
  steps: [
    {
      title: "Find your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the Kentik portal, click your username in the top-right corner and go to your **User Profile**. Select the **Authentication** tab to find your API token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Email",
          required: true,
          placeholder: "user@example.com",
          target: { kind: "configuration", field: "email" },
          helperText: "The email address associated with your Kentik account.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
          helperText: "Your Kentik API token from the Authentication tab.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.kentik.com/api/v5/users",
  },
});
